// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"b0443a6a","307":"12940fb2","407":"000c9b39","506":"d826d232","534":"90eadda8","538":"7502cfce","545":"363a01e3","566":"33209b05","614":"084c75c7","808":"2286b835","843":"e2e98c06","894":"65578247","928":"5af4460d"}[chunkId] + ".chunk.js";
};